import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f58944f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  key: 0,
  class: "modal"
}
const _hoisted_3 = { class: "modal-left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "添加快捷方式", -1))
const _hoisted_5 = { class: "left-tree" }
const _hoisted_6 = { class: "type-cont" }
const _hoisted_7 = {
  key: 0,
  class: "type-name"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "modal-right" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { style: {"flex-shrink":"0"} }
const _hoisted_12 = { class: "close-btn" }

import { ref, onMounted, watch, onBeforeUnmount, nextTick } from 'vue';
import CommonComp from './CommonComp.vue';
import { Close } from '@rafter/icon';
import { RaInput } from '@rafter/pc';
import CustomMark from './CustomMark.vue';
import NewFinds from './NewFind.vue';
import SearchComp from './SearchComp.vue';
import { getIconTypes } from '@/api/baseApi';

export default /*#__PURE__*/_defineComponent({
  __name: 'AddComp',
  props: {
  categorie: {
    type: Object,
    default: () => {},
  },
  detail: {
    type: Object,
    default: null,
  },
},
  emits: ['handleClose', 'getMarks'],
  setup(__props, { emit: emits }) {

const props = __props;



const fastList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 0];
const compList = [15, 16, 17];
const searchKey = ref('');
const inputRef = ref();
const isShow = ref(false);
const searchCompRef = ref();
const selectedItem = ref({
  name: '最新发现',
  value: 'new_find',
  id: null,
});
const getMarks = () => {
  emits('getMarks');
};
const typeList = ref([
  {
    type: 'new',
    name: '',
    items: [
      {
        name: '最新发现',
        value: 'new_find',
        icon: 'icon-onetabchangyong',
      },
      {
        name: '自定义书签',
        value: 'marks',
        icon: 'icon-onetabzidingyishuqian',
      },
    ],
  },
  {
    type: 'comp',
    name: '小组件',
    id: 14,
    items: [
      {
        name: '常用',
        value: 'little-comp',
        icon: 'icon-onetabicon-17',
        id: 15,
      },
      {
        name: 'AI系列',
        value: 'ai',
        icon: 'icon-onetabAI',
        id: 16,
      },
      {
        name: '效率工具',
        value: 'tool',
        icon: 'icon-onetabicon-05',
        id: 17,
      },
    ],
  },
  {
    type: 'fast',
    name: '快捷方式',
    items: [
      {
        name: '热门',
        value: 'common',
        icon: 'icon-onetabremen',
        id: 0,
      },
      {
        name: '新闻',
        value: 'news',
        icon: 'icon-onetabxinwen',
        id: 1,
      },
      {
        name: '音乐',
        value: 'music',
        icon: 'icon-onetabmusic',
        id: 2,
      },
      {
        name: '图片',
        value: 'photos',
        icon: 'icon-onetabtupian',
        id: 3,
      },
      {
        name: '购物',
        value: 'shopping',
        icon: 'icon-onetabicon-31',
        id: 4,
      },
      {
        name: '社交',
        value: 'social',
        icon: 'icon-onetabshejiao',
        id: 5,
      },
      {
        name: '运动',
        value: 'sports',
        icon: 'icon-onetabicon-18',
        id: 6,
      },
      {
        name: '生活',
        value: 'life',
        icon: 'icon-onetabshenghuo',
        id: 7,
      },
      {
        name: '游戏',
        value: 'games',
        icon: 'icon-onetabyouxi',
        id: 8,
      },
      {
        name: '教育',
        value: 'education',
        icon: 'icon-onetabjiaoyu',
        id: 9,
      },
      {
        name: '科技',
        value: 'tech',
        icon: 'icon-onetabkeji',
        id: 10,
      },
      {
        name: '金融',
        value: 'finance',
        icon: 'icon-onetabjinrong',
        id: 11,
      },
      {
        name: '阅读',
        value: 'read',
        icon: 'icon-onetabicon-32',
        id: 12,
      },
      {
        name: '其他',
        value: 'others',
        icon: 'icon-onetabicon-21',
        id: 13,
      },
    ],
  },
]);

const handleItem = (item: { name: string; value: string }) => {
  searchKey.value = '';
  selectedItem.value = item;
};
/**
 * @name:
 * @description: 关闭弹窗
 * @msg:
 * @return {*}
 */
const handleClose = () => {
  isShow.value = false;
  setTimeout(() => {
    emits('handleClose');
  }, 150);
};
const handleChange = (value) => {
  searchCompRef.value?.getSearchList();
};
watch(
  () => searchKey.value,
  () => {
    if (!searchKey.value) {
      inputRef.value?.handleClearClick();
    }
  }
);
watch(
  () => [props.detail],
  () => {
    // 编辑
    if (props.detail?.name) {
      selectedItem.value = {
        name: '自定义书签',
        value: 'marks',
        id: null,
      };
    }
  }
);
onMounted(() => {
  isShow.value = true;
  document.addEventListener('keydown', handleKeyDown);
  if (props.detail?.name) {
    selectedItem.value = {
      name: '自定义书签',
      value: 'marks',
      id: null,
    };
  }
});
watch(
  () => [selectedItem.value],
  () => {
    if (selectedItem.value.value === 'common') {
      nextTick(() => {
        inputRef.value.focus();
      });
    }
  }
);
const handleKeyDown = (event) => {
  if (event.key === 'Escape') {
    handleClose();
  }
};
onBeforeUnmount(() => {
  document.removeEventListener('keydown', handleKeyDown);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "mask",
    onClick: _withModifiers(handleClose, ["self"])
  }, [
    _createVNode(_Transition, { name: "modal-fade" }, {
      default: _withCtx(() => [
        (isShow.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_unref(RaInput), {
                    type: "text",
                    modelValue: searchKey.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchKey).value = $event)),
                    class: "search-input",
                    ref_key: "inputRef",
                    ref: inputRef,
                    clearable: "",
                    onChange: handleChange,
                    placeholder: "按Enter搜索"
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeList.value, (types) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "type-list",
                        key: types.name
                      }, [
                        (types.name)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(types.name), 1))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(types.items, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item.name,
                            class: _normalizeClass({
                    item: true,
                    active: selectedItem.value.name === item.name,
                  }),
                            onClick: ($event: any) => (handleItem(item))
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass({ iconfont: true, [item.icon]: true })
                            }, null, 2),
                            _createTextVNode(" " + _toDisplayString(item.name), 1)
                          ], 10, _hoisted_8))
                        }), 128))
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(searchKey.value ? `“${searchKey.value}”的结果` : selectedItem.value.name), 1),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_unref(Close), {
                      size: 14,
                      onClick: handleClose
                    })
                  ])
                ]),
                (!searchKey.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (selectedItem.value.value === 'new_find')
                        ? (_openBlock(), _createBlock(NewFinds, { key: 0 }))
                        : _createCommentVNode("", true),
                      (fastList.includes(selectedItem.value.id))
                        ? (_openBlock(), _createBlock(CommonComp, {
                            key: 1,
                            categorie: props.categorie,
                            onGetMarks: getMarks,
                            searchKey: searchKey.value,
                            "sort-id": selectedItem.value.id
                          }, null, 8, ["categorie", "searchKey", "sort-id"]))
                        : _createCommentVNode("", true),
                      (selectedItem.value.value === 'marks')
                        ? (_openBlock(), _createBlock(CustomMark, {
                            key: 2,
                            type: "content",
                            onHandleClose: handleClose,
                            categorie: props.categorie,
                            onGetMarks: getMarks,
                            detail: __props.detail
                          }, null, 8, ["categorie", "detail"]))
                        : _createCommentVNode("", true),
                      (compList.includes(selectedItem.value.id))
                        ? (_openBlock(), _createBlock(CommonComp, {
                            key: 3,
                            categorie: props.categorie,
                            onGetMarks: getMarks,
                            searchKey: searchKey.value,
                            type: "little-comp",
                            "sort-id": selectedItem.value.id
                          }, null, 8, ["categorie", "searchKey", "sort-id"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (searchKey.value)
                  ? (_openBlock(), _createBlock(SearchComp, {
                      key: 1,
                      ref_key: "searchCompRef",
                      ref: searchCompRef,
                      searchKey: searchKey.value
                    }, null, 8, ["searchKey"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 8, _hoisted_1))
}
}

})